/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_Text from 'canvas/base/dev/child/text/B_Text';
import B_Define from 'canvas/base/dev/util/B_Define';

let mix = (superclass) => new MixinBuilder(superclass);

const B_ToolCountDown = (function () {

	class B_ToolCountDown extends mix(B_Real).with(B_Text) {
		constructor(obj) {
			super(obj);

			// [S] init scale
 			this._scaleX = 0;
			this._scaleY = 0;
		}

		// [F]


		/**
		 * @DES :: 애니메이션 재귀함수
		 * @IP1 :: num {num}
		 * @IP2 :: cb {func}
		 * @S.E ::
		 */
		_bigToSmall(num, cb) {
			this._object.text = num;
			this._scaleX = B_Define.COUNTDOWN_BIG_SCALE;
			this._scaleY = B_Define.COUNTDOWN_BIG_SCALE;
			this._setPoint(50, 50);

			this.CODMOS.ANIMATE._tween.tween(this, '',
				{
					arrStep: [
						{
							option: {scaleX: 0, scaleY: 0},
							time: B_Define.COUNTDOWN_ANIMATE_TIME,
							effect: 'none'
						}
					]
				}, () => {
					if (num - 1 == 0) { if(cb) cb(); }
					else { this._bigToSmall(num - 1, cb); }
				});
		}

		/**
		 * @DES :: 카운드다운 시작
		 * @IP1 :: cb {func}
		 * @O.P ::
		 * @S.E ::
		 */
		start(cb) {
			this._bigToSmall(B_Define.COUNTDOWN_INIT_TIME, cb);
		}
	}

	return B_ToolCountDown;
}());

export default B_ToolCountDown;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_ToolCountDown.js